/** Objeto que contiene información sobre los medios de pago. */

export default class CommonPaymentMeans {
  /** (String): Nombre del titular del medio de pago. */
  holderName!: string

  /** (String): Número IBAN de la cuenta bancaria. */
  iban!: string

  constructor(data: any) {
    this.holderName = data.holderName
    this.iban = data.iban
  }
}
